const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesTrend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.9489 12C31.2004 5.265 25.4823 0 18.5667 0C11.6511 0 5.93305 5.265 5.18461 12H0.574219L3.44823 32.13C3.76258 34.335 5.67858 36 7.89397 36H29.2545C31.4699 36 33.3859 34.335 33.7002 32.13L36.5742 12H31.9638H31.9489ZM18.5667 3C23.8358 3 28.1917 6.915 28.9252 12H8.20831C8.94179 6.915 13.2977 3 18.5667 3Z",
    fill: "#2F2F2F",
    style: {
      fill: "#2F2F2F",
      fill: "color(display-p3 0.1863 0.1863 0.1863)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1246 17.8438H21.6831C20.9476 17.8438 20.3507 18.4419 20.3507 19.179C20.3507 19.916 20.9476 20.5142 21.6831 20.5142H24.6847L19.4624 25.7474L15.8035 22.0809C14.8823 21.1578 13.3829 21.1578 12.4617 22.0809L8.30447 26.2459C7.78393 26.7675 7.78393 27.6122 8.30447 28.1339C8.82501 28.6555 9.66801 28.6555 10.1886 28.1339L14.1317 24.1825L17.7906 27.849C18.2516 28.311 18.8557 28.5416 19.4615 28.5416C20.0673 28.5416 20.6714 28.3101 21.1324 27.849L26.5679 22.4022V25.41C26.5679 26.1471 27.1648 26.7452 27.9003 26.7452C28.6359 26.7452 29.2328 26.1471 29.2328 25.41V20.9593C29.2328 19.2413 27.839 17.8438 26.1246 17.8438Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTrend);
export default __webpack_public_path__ + "static/media/sales-trend.bcc5720489f3a65271643540871c3b83.svg";
export { ForwardRef as ReactComponent };